import React from 'react';
import moment from 'moment/moment';
import PieLinerIcon from '../../../../icons/PieLinerIcon.jsx';
import { ChangeImpactLink } from '../../../../links/index.jsx';
import SentimentDot from '../../../../SentimentDot.jsx';

const ImpactCard = ({ impact }) => {
  return (
    <div className="milestone-card m-t-28">
      <div className="m-b-16 text-left">
        <h4 className="m-b-14 text-primary flex flex-align-center">
          <PieLinerIcon />
          <ChangeImpactLink
            changeImpactId={impact.id}
            projectId={impact.projectId}
          >
            <a>
              <span className="m-l-8 text-primary cursor-pointer">
                {impact.title}
              </span>
            </a>
          </ChangeImpactLink>
        </h4>

        <div className="m-b-12 m-l-32">
          <span
            className="text-muted"
            style={{ display: 'inline-block', minWidth: '115px' }}
          >
            Dates:{' '}
          </span>
          <span className="">
            {moment(impact.startDate).format('MM/DD/YY')}-
            {moment(impact.endDate).format('MM/DD/YY')}
          </span>
        </div>
        <div className="m-b-12 m-l-32">
          <span
            className="text-muted"
            style={{ display: 'inline-block', minWidth: '115px' }}
          >
            Scale:{' '}
          </span>
          <SentimentDot sentiment={impact.scale} reverse />
          {impact.scale ? (
            <span className="text-capitalize">{impact.scale}</span>
          ) : (
            <span className="text-capitalize">—</span>
          )}
        </div>
        <div className="m-b-12 m-l-32">
          <span
            className="text-muted"
            style={{ display: 'inline-block', minWidth: '115px' }}
          >
            Perception:{' '}
          </span>
          <SentimentDot sentiment={impact.perception} />
          {impact.perception ? (
            <span className="text-capitalize">{impact.perception}</span>
          ) : (
            <span className="text-capitalize">—</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImpactCard;
